import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { GlobalService } from '../global.service';

import { PopupQuestionComponent } from './components/popup-question/popup-question.component';
import { MatDialog, MatDialogConfig,MAT_DIALOG_DATA  } from '@angular/material';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit {
  
  public companyName;
  public tabActive='Dashboard';
  constructor(private router:Router,public appComponent:AppComponent,private services: Service,private loadingScreenService:LoadingScreenService,private global:GlobalService, public dialog:MatDialog,public AngularFireAnalytics:AngularFireAnalytics){
    this.AngularFireAnalytics.setCurrentScreen("Dashboard");
    this.AngularFireAnalytics.logEvent("Dashboard-Screenview");
  }
          
  ngOnInit(){
    if(this.global.validateSession()==true){
      this.companyName=atob(sessionStorage.getItem("companyName"));
      var popPreguntasSeguridad=JSON.parse(atob(sessionStorage.getItem("popPreguntasSeguridad")));
      if(popPreguntasSeguridad==true){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true
        const dialogRef =this.dialog.open(PopupQuestionComponent, dialogConfig);  
      }
    }
  }
}